import Swiper from 'swiper';
import { principalConfig, thumbsConfig } from '../utils/slider-configuration';
import { $Q } from '../utils/query-selector';
import "swiper/css/grid";
import "swiper/css";

export function mountSlider(main) {
  const {
    dataset: { direction = null },
  } = main;
  let thumbnails;
  let principalClass;

  const typeSlider = {
    'horizontal-outside': () => renderHorizontal(),
    'vertical-left': () => renderVerticalOutside(),
    'vertical-right': () => renderVerticalOutside(),
    'vertical-inside': () => renderVerticalInside(),
    'horizontal-inside': () => renderHorizontalInside(),
  };

  const renderHorizontal = () => {
    /**
     * HORIZONTAL SWIPER SLIDER: media product page
     */
    thumbnails = new Swiper(
      '.horizontal-swipper-thumbs',
      thumbsConfig(1, false)
    );
    principalClass = '.horizontal-swipper-principal';
  };

  const renderVerticalOutside = () => {
    /**
     * VERTICAL SWIPER SLIDER LEFT OUTSIDE: media product page
     */
    thumbnails =
      $Q('.vertical-outside-swipper-thumbs') &&
      new Swiper('.vertical-outside-swipper-thumbs', thumbsConfig(5, true));
    principalClass = '.vertical-outside-swipper-principal';
  };

  const renderVerticalInside = () => {
    /**
     * VERTICAL SWIPER SLIDER INSIDE: media product page
     */
    thumbnails = new Swiper(
      '.vertical-inside-swipper-thumbs',
      thumbsConfig(4, true)
    );
    principalClass = '.vertical-inside-swipper-principal';
  };

  const renderHorizontalInside = () => {
    /**
     * HORIZONTAL SWIPER SLIDER INSIDE: media product page
     */
    thumbnails = new Swiper(
      '.horizontal-inside-swipper-thumbs',
      thumbsConfig(5, false)
    );
    principalClass = '.horizontal-inside-swipper-principal';
  };

  typeSlider[direction]();

  // eslint-disable-next-line no-unused-expressions
  direction && new Swiper(principalClass, principalConfig(thumbnails));
  // eslint-disable-next-line no-unused-expressions
}
